import { Mapper } from "src/app/base/mapper";
import { IBranchExchangeEntity } from "../entity/branch-exchange.entity";
import { IBranchExchangeModel } from "../models/branch-exchange.model";

export class BranchExchangeImplementationRepositoryMapper extends Mapper<IBranchExchangeEntity, IBranchExchangeModel> {
	override mapFrom(param: IBranchExchangeEntity): IBranchExchangeModel {
    return {
      id: param.id,
      name: param.branchName,
      exchange: param.exchange.filter((value: any) => {
        return value.currency.code !== 'MXN';
      })
    };
	}

	override mapTo(param: IBranchExchangeModel): IBranchExchangeEntity {
    return {
      id: param.id,
      branchName: param.name,
      exchange: param.exchange.filter((value: any) => {
        return value.currency.code !== 'MXN';
      })
    };
	}

}